import { IExportBehavior } from './behavior';
import { IExportState } from './state';

/**
 * 插件类型
 */
export enum PluginType {
    /** 视口插件 */
    VIEWPORT = 'viewport',
    /** 舞台插件 */
    STAGE = 'stage',
    /** 系统插件 */
    SYSTEM = 'system',
    /** 图层插件 */
    LAYER = 'layer',
    /** 扩展插件 */
    EXTENSION = 'extension',
}

/**
 * 插件选项
 */
export interface IRegisterPluginOptions {
    /** 是否启用渲染 */
    enable?: boolean;
    /** 插件 */
    plugin: IExportPlugin;
}

/** 基础类实例 */
export type BaseClassInstance = new (...args: any[]) => any;

/**
 * 插件
 */
export interface IExportPlugin {
    /** 插件类型 */
    type: PluginType;
    /** 排序 */
    sort: number;
    /** 插件名称 */
    name: string;
    /** 创建代码实例 */
    createInstance?(args: { identity: string }): { key: string; value: InstanceType<BaseClassInstance> }[];
    /** 创建自定义历史记实例 */
    createHistory?(args: { identity: string }): InstanceType<BaseClassInstance>[];
    /** 创建自定义状态实例 */
    createState?(): IExportState[];
    /** 创建图层行为 */
    createBehavior?(): IExportBehavior;
    /** 编辑器数据初始化 */
    destroy?(args: {
        identity: string;
        getInstance<T extends BaseClassInstance>(classConstructor: T): InstanceType<T>;
    }): void;
    /** 渲染插件, 不存在 render 会导致插件无法挂载 */
    render?(): React.ReactNode;
    /** 依赖插件 */
    dependencies?(): IRegisterPluginOptions[];
}
